import { render, staticRenderFns } from "./Sikayet.vue?vue&type=template&id=547a91fe&"
import script from "./Sikayet.vue?vue&type=script&lang=js&"
export * from "./Sikayet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports